module.exports = __webpack_public_path__ + "img/54.4.NH3-N.a79ca70e.png";